import { render } from "./PortfolioCard.vue?vue&type=template&id=7806f2a2&scoped=true"
import script from "./PortfolioCard.vue?vue&type=script&lang=js"
export * from "./PortfolioCard.vue?vue&type=script&lang=js"

import "./PortfolioCard.vue?vue&type=style&index=0&id=7806f2a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7806f2a2"]])

export default __exports__